/**
 * Срок и причина блокировки, снятые с отказа шлюза.
 *
 * Страница «аккаунт заблокирован» открывается уже анонимной — куку шлюз стирает в тот же
 * момент, — поэтому спросить эти две вещи ей потом не у кого. Единственная возможность узнать
 * их наступает ровно один раз: когда запрос вернулся с отказом. Здесь мы её и ловим.
 *
 * Хранилище сеансовое намеренно: это не настройка, а записка самому себе на один переход.
 * Любое обращение к нему обёрнуто — в приватном окне и при запрете хранения оно бросает,
 * а страница обязана открыться и без записки.
 */
const STORAGE_KEY = 'tp:ban-notice';

export type BanNotice = {
  /** ISO-дата, до которой держится блокировка. Пусто — блокировка бессрочная. */
  bannedUntil?: string;
  /** Код причины из короткого списка. Пусто — причину не выбрали при старых блокировках. */
  reason?: string;
};

export const rememberBanNotice = (extensions: Record<string, unknown> | undefined) => {
  if (!extensions) return;

  const notice: BanNotice = {};
  if (typeof extensions.bannedUntil === 'string') notice.bannedUntil = extensions.bannedUntil;
  if (typeof extensions.banReason === 'string') notice.reason = extensions.banReason;
  if (!notice.bannedUntil && !notice.reason) return;

  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(notice));
  } catch {
    // Приватное окно или запрет хранения: страница покажет общий текст, это допустимо.
  }
};

export const readBanNotice = (): BanNotice | null => {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const { bannedUntil, reason } = parsed as BanNotice;
    return {
      bannedUntil: typeof bannedUntil === 'string' ? bannedUntil : undefined,
      reason: typeof reason === 'string' ? reason : undefined,
    };
  } catch {
    return null;
  }
};
